import { Chip, Stack, StackProps } from "@mui/material"
import { AuthorResult } from "interface/author"

type AuthorFlagsProps = {
	author: AuthorResult
} & StackProps
export const AuthorFlags = ({
	author,
	...others
}: AuthorFlagsProps) => {
	return (
		<Stack {...others} direction="row" alignItems="center" spacing={0.5} flexWrap="wrap" useFlexGap>
			{author.rank ? <Chip variant="filled" color="success" label={`論文${author.rank}位`} size="small" /> : <></>}
		</Stack>
	)	
}
